(function () {
  'use strict';

  var config = window.BourneMaintenanceConfig || {};
  var apiUrl = config.apiUrl || 'https://agencyosportal.com/api/maintenance-report';
  var uploadUrl = config.uploadUrl || 'https://agencyosportal.com/api/maintenance-upload';

  var css = [
    '#bnc-widget-btn{position:fixed;bottom:24px;right:24px;z-index:9998;background:#1d4ed8;color:#fff;border:none;border-radius:50px;padding:14px 22px;font-size:15px;font-weight:600;cursor:pointer;box-shadow:0 4px 16px rgba(29,78,216,.4);display:flex;align-items:center;gap:8px;transition:background .2s,transform .1s;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
    '#bnc-widget-btn:hover{background:#1e40af;transform:translateY(-1px);}',
    '#bnc-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;justify-content:center;align-items:flex-end;}',
    '#bnc-overlay.bnc-active{display:flex;}',
    '#bnc-panel{background:#fff;width:100%;max-width:500px;max-height:90vh;overflow-y:auto;border-radius:16px 16px 0 0;padding:28px 24px 32px;box-shadow:0 -8px 40px rgba(0,0,0,.2);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-sizing:border-box;position:relative;}',
    '@media(min-width:600px){#bnc-overlay{align-items:center;}#bnc-panel{border-radius:16px;max-height:82vh;}}',
    '#bnc-panel h2{font-size:20px;font-weight:700;color:#111;margin:0 0 4px;}',
    '#bnc-panel .bnc-sub{font-size:13px;color:#6b7280;margin:0 0 20px;}',
    '.bnc-field{margin-bottom:14px;}',
    '.bnc-field label{display:block;font-size:13px;font-weight:600;color:#374151;margin-bottom:4px;}',
    '.bnc-field input,.bnc-field select,.bnc-field textarea{width:100%;box-sizing:border-box;padding:10px 12px;border:1.5px solid #d1d5db;border-radius:8px;font-size:14px;color:#111;background:#fff;transition:border-color .15s;font-family:inherit;}',
    '.bnc-field input:focus,.bnc-field select:focus,.bnc-field textarea:focus{outline:none;border-color:#1d4ed8;box-shadow:0 0 0 3px rgba(29,78,216,.1);}',
    '.bnc-field textarea{resize:vertical;min-height:80px;}',
    '.bnc-row{display:grid;grid-template-columns:1fr 1fr;gap:12px;}',
    '#bnc-upload-area{border:2px dashed #d1d5db;border-radius:8px;padding:16px;text-align:center;cursor:pointer;transition:border-color .2s,background .2s;background:#f9fafb;}',
    '#bnc-upload-area:hover,#bnc-upload-area.bnc-drag{border-color:#1d4ed8;background:#eff6ff;}',
    '#bnc-upload-area p{margin:4px 0;font-size:13px;color:#6b7280;}',
    '#bnc-upload-area strong{color:#1d4ed8;}',
    '#bnc-file-input{display:none;}',
    '#bnc-previews{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px;}',
    '.bnc-pv{position:relative;width:72px;height:72px;border-radius:6px;overflow:hidden;background:#e5e7eb;flex-shrink:0;}',
    '.bnc-pv img{width:100%;height:100%;object-fit:cover;}',
    '.bnc-pv-vid{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:26px;}',
    '.bnc-pv button{position:absolute;top:2px;right:2px;background:rgba(0,0,0,.6);color:#fff;border:none;border-radius:50%;width:18px;height:18px;font-size:12px;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;line-height:1;}',
    '.bnc-upload-hint{font-size:11px;color:#9ca3af;margin-top:4px;}',
    '#bnc-submit{width:100%;padding:13px;background:#1d4ed8;color:#fff;border:none;border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;margin-top:18px;transition:background .2s;font-family:inherit;}',
    '#bnc-submit:hover{background:#1e40af;}',
    '#bnc-submit:disabled{background:#93c5fd;cursor:not-allowed;}',
    '#bnc-msg{margin-top:12px;padding:12px;border-radius:8px;font-size:14px;display:none;}',
    '#bnc-msg.bnc-ok{background:#d1fae5;color:#065f46;display:block;}',
    '#bnc-msg.bnc-err{background:#fee2e2;color:#991b1b;display:block;}',
    '.bnc-x{position:absolute;top:14px;right:16px;background:none;border:none;font-size:24px;cursor:pointer;color:#6b7280;line-height:1;padding:4px;}',
    '.bnc-divider{border:none;border-top:1px solid #e5e7eb;margin:4px 0 14px;}',
    '#bnc-sec2-wrap{margin-bottom:14px;}',
    '#bnc-add-sec2{font-size:13px;color:#1d4ed8;text-decoration:none;font-weight:500;background:none;border:none;cursor:pointer;padding:0;font-family:inherit;}',
    '#bnc-add-sec2:hover{text-decoration:underline;}',
    '#bnc-sec2{display:none;margin-top:10px;}'
  ].join('');

  function inject() {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    // Floating button
    var btn = document.createElement('button');
    btn.id = 'bnc-widget-btn';
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M4.93 19.07a10 10 0 0 1 0-14.14M8.46 15.54a5 5 0 0 1 0-7.07"/></svg>Report a Repair';
    document.body.appendChild(btn);

    // Overlay
    var overlay = document.createElement('div');
    overlay.id = 'bnc-overlay';
    overlay.innerHTML = '<div id="bnc-panel">'
      + '<button class="bnc-x" id="bnc-close" aria-label="Close">&times;</button>'
      + '<h2>Report a Repair</h2>'
      + '<p class="bnc-sub">Fill in the form and we\'ll log a repair request right away.</p>'

      // Who is reporting
      + '<div class="bnc-field"><label for="bnc-rep">Who is reporting this? *</label>'
      +   '<select id="bnc-rep">'
      +     '<option value="tenant" selected>Tenant</option>'
      +     '<option value="landlord">Landlord</option>'
      +     '<option value="agency">Agency</option>'
      +     '<option value="other">Other</option>'
      +   '</select></div>'

      // Name + phone
      + '<div class="bnc-row">'
      +   '<div class="bnc-field"><label for="bnc-nm">Full name *</label>'
      +     '<input id="bnc-nm" type="text" placeholder="Jane Smith" autocomplete="name"></div>'
      +   '<div class="bnc-field"><label for="bnc-ph">Phone number</label>'
      +     '<input id="bnc-ph" type="tel" placeholder="07700 000 000" autocomplete="tel"></div>'
      + '</div>'

      // Email
      + '<div class="bnc-field"><label for="bnc-em">Email address *</label>'
      +   '<input id="bnc-em" type="email" placeholder="jane@example.com" autocomplete="email"></div>'

      // Second contact toggle
      + '<div id="bnc-sec2-wrap">'
      +   '<button type="button" id="bnc-add-sec2">+ Add a second contact</button>'
      +   '<div id="bnc-sec2">'
      +     '<div class="bnc-row">'
      +       '<div class="bnc-field"><label for="bnc-nm2">Second contact name</label>'
      +         '<input id="bnc-nm2" type="text" placeholder="John Smith"></div>'
      +       '<div class="bnc-field"><label for="bnc-ph2">Second contact phone</label>'
      +         '<input id="bnc-ph2" type="tel" placeholder="07700 000 000"></div>'
      +     '</div>'
      +   '</div>'
      + '</div>'

      // Property address
      + '<div class="bnc-field"><label for="bnc-ad">Property address *</label>'
      +   '<input id="bnc-ad" type="text" placeholder="123 High Street, Lanchester, DH7 0AA"></div>'

      // Priority + Category
      + '<div class="bnc-row">'
      +   '<div class="bnc-field"><label for="bnc-urg">Priority</label>'
      +     '<select id="bnc-urg">'
      +       '<option value="routine" selected>Routine</option>'
      +       '<option value="urgent">Urgent</option>'
      +       '<option value="emergency">Emergency</option>'
      +     '</select></div>'
      +   '<div class="bnc-field"><label for="bnc-cat">Category</label>'
      +     '<select id="bnc-cat">'
      +       '<option value="">Select type</option>'
      +       '<option value="plumbing">Plumbing</option>'
      +       '<option value="electrical">Electrical</option>'
      +       '<option value="heating">Heating / Boiler</option>'
      +       '<option value="structural">Structural</option>'
      +       '<option value="damp">Damp / Mould</option>'
      +       '<option value="appliances">Appliances</option>'
      +       '<option value="other">Other</option>'
      +     '</select></div>'
      + '</div>'

      // Issue description
      + '<div class="bnc-field"><label for="bnc-iss">Describe the issue *</label>'
      +   '<textarea id="bnc-iss" placeholder="Please describe the problem in as much detail as possible…"></textarea></div>'

      // Access notes
      + '<div class="bnc-field"><label for="bnc-acc">Access notes</label>'
      +   '<input id="bnc-acc" type="text" placeholder="e.g. key with neighbour, call before visiting"></div>'

      // Photos / Videos
      + '<div class="bnc-field">'
      +   '<label>Photos / Videos</label>'
      +   '<div id="bnc-upload-area" role="button" tabindex="0">'
      +     '<p>📎 <strong>Click to add photos or videos</strong></p>'
      +     '<p>or drag &amp; drop here</p>'
      +   '</div>'
      +   '<input id="bnc-file-input" type="file" multiple accept="image/jpeg,image/png,image/gif,image/webp,video/mp4,video/quicktime">'
      +   '<div id="bnc-previews"></div>'
      +   '<p class="bnc-upload-hint">Up to 5 files &middot; JPG, PNG, GIF, WebP, MP4 or MOV &middot; max 10 MB each</p>'
      + '</div>'

      + '<input type="text" id="bnc-hp" style="display:none" tabindex="-1" autocomplete="off">'
      + '<button id="bnc-submit" type="button">Submit Report</button>'
      + '<div id="bnc-msg"></div>'
      + '</div>';
    document.body.appendChild(overlay);

    var selectedFiles = [];

    function open() {
      overlay.classList.add('bnc-active');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.classList.remove('bnc-active');
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', open);
    document.getElementById('bnc-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('bnc-active')) close();
    });

    // Second contact toggle
    var sec2Toggle = document.getElementById('bnc-add-sec2');
    var sec2Panel  = document.getElementById('bnc-sec2');
    var sec2Open   = false;
    sec2Toggle.addEventListener('click', function () {
      sec2Open = !sec2Open;
      sec2Panel.style.display = sec2Open ? 'block' : 'none';
      sec2Toggle.textContent  = sec2Open ? '− Remove second contact' : '+ Add a second contact';
      if (!sec2Open) {
        document.getElementById('bnc-nm2').value = '';
        document.getElementById('bnc-ph2').value = '';
      }
    });

    // File handling
    var uploadArea = document.getElementById('bnc-upload-area');
    var fileInput  = document.getElementById('bnc-file-input');
    var previews   = document.getElementById('bnc-previews');

    uploadArea.addEventListener('click', function () { fileInput.click(); });
    uploadArea.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
    });
    uploadArea.addEventListener('dragover', function (e) {
      e.preventDefault(); uploadArea.classList.add('bnc-drag');
    });
    uploadArea.addEventListener('dragleave', function () {
      uploadArea.classList.remove('bnc-drag');
    });
    uploadArea.addEventListener('drop', function (e) {
      e.preventDefault(); uploadArea.classList.remove('bnc-drag');
      addFiles(Array.from(e.dataTransfer.files));
    });
    fileInput.addEventListener('change', function () {
      addFiles(Array.from(fileInput.files));
      fileInput.value = '';
    });

    function addFiles(files) {
      var space = 5 - selectedFiles.length;
      if (space <= 0) return;
      files.slice(0, space).forEach(function (f) {
        if (f.size > 10 * 1024 * 1024) { alert(f.name + ' exceeds the 10 MB limit and was not added.'); return; }
        selectedFiles.push(f);
        renderPreview(f, selectedFiles.length - 1);
      });
    }

    function renderPreviews() {
      previews.innerHTML = '';
      selectedFiles.forEach(renderPreview);
    }

    function renderPreview(f, i) {
      var item = document.createElement('div');
      item.className = 'bnc-pv';
      if (f.type.startsWith('video/')) {
        item.innerHTML = '<div class="bnc-pv-vid">🎬</div>';
      } else {
        var img = document.createElement('img');
        img.alt = f.name;
        img.src = URL.createObjectURL(f);
        item.appendChild(img);
      }
      var rm = document.createElement('button');
      rm.textContent = '×';
      rm.setAttribute('aria-label', 'Remove');
      rm.setAttribute('data-i', i);
      rm.addEventListener('click', function () {
        selectedFiles.splice(parseInt(this.getAttribute('data-i'), 10), 1);
        renderPreviews();
      });
      item.appendChild(rm);
      previews.appendChild(item);
    }

    function msg(text, cls) {
      var el = document.getElementById('bnc-msg');
      el.textContent = text;
      el.className = cls;
    }

    function setBtn(disabled, label) {
      var el = document.getElementById('bnc-submit');
      el.disabled = disabled;
      el.textContent = label || 'Submit Report';
    }

    function b64(file) {
      return new Promise(function (res, rej) {
        var r = new FileReader();
        r.onload = function () { res(r.result); };
        r.onerror = rej;
        r.readAsDataURL(file);
      });
    }

    document.getElementById('bnc-submit').addEventListener('click', function () { submit(); });

    function submit() {
      var reportedBy  = document.getElementById('bnc-rep').value;
      var name        = (document.getElementById('bnc-nm').value || '').trim();
      var email       = (document.getElementById('bnc-em').value || '').trim();
      var phone       = (document.getElementById('bnc-ph').value || '').trim();
      var name2       = (document.getElementById('bnc-nm2').value || '').trim();
      var phone2      = (document.getElementById('bnc-ph2').value || '').trim();
      var address     = (document.getElementById('bnc-ad').value || '').trim();
      var issue       = (document.getElementById('bnc-iss').value || '').trim();
      var priority    = document.getElementById('bnc-urg').value;
      var category    = document.getElementById('bnc-cat').value;
      var access      = (document.getElementById('bnc-acc').value || '').trim();
      var hp          = (document.getElementById('bnc-hp').value || '');

      if (!name)    { msg('Please enter your full name.', 'bnc-err'); return; }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msg('Please enter a valid email address.', 'bnc-err'); return;
      }
      if (!address) { msg('Please enter the property address.', 'bnc-err'); return; }
      if (!issue)   { msg('Please describe the issue.', 'bnc-err'); return; }

      msg('', '');
      setBtn(true, 'Uploading…');

      var photoPromise = selectedFiles.length > 0
        ? Promise.all(selectedFiles.map(function (f) {
            return b64(f).then(function (data) { return { name: f.name, type: f.type, data: data }; });
          })).then(function (payload) {
            return fetch(uploadUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ files: payload })
            }).then(function (r) { return r.ok ? r.json() : { urls: [] }; });
          }).catch(function () { return { urls: [] }; })
        : Promise.resolve({ urls: [] });

      photoPromise.then(function (up) {
        setBtn(true, 'Submitting…');
        var body = {
          reportedBy:        reportedBy,
          tenantName:        name,
          tenantEmail:       email,
          tenantPhone:       phone,
          propertyAddress:   address,
          description:       issue,
          priority:          priority,
          category:          category,
          accessNotes:       access,
          photoUrls:         up.urls || [],
          honeypot:          hp,
          source:            'website-widget',
          submitted_at:      new Date().toISOString()
        };
        if (name2)  body.secondContactName  = name2;
        if (phone2) body.secondContactPhone = phone2;
        return fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
      }).then(function (r) {
        if (r.ok) {
          msg('✅ Repair reported! You\'ll receive a confirmation email shortly.', 'bnc-ok');
          ['bnc-nm','bnc-em','bnc-ph','bnc-ad','bnc-iss','bnc-acc'].forEach(function (id) {
            document.getElementById(id).value = '';
          });
          document.getElementById('bnc-rep').value = 'tenant';
          document.getElementById('bnc-urg').value = 'routine';
          document.getElementById('bnc-cat').value = '';
          // Reset second contact
          document.getElementById('bnc-nm2').value = '';
          document.getElementById('bnc-ph2').value = '';
          sec2Open = false;
          sec2Panel.style.display = 'none';
          sec2Toggle.textContent  = '+ Add a second contact';
          selectedFiles = [];
          previews.innerHTML = '';
          setBtn(false);
        } else {
          return r.json().catch(function () { return {}; }).then(function (d) {
            msg(d.error || 'Something went wrong. Please try again or call us directly.', 'bnc-err');
            setBtn(false);
          });
        }
      }).catch(function () {
        msg('Connection error. Please check your internet and try again.', 'bnc-err');
        setBtn(false);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
